"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchAPI = exports.SEARCH = void 0;
const http_1 = require("@completeanatomy/http");
exports.SEARCH = '/h/eca/apigw/search/wc';
class SearchAPI {
    constructor(http, config) {
        this.http = http;
        this.config = config;
    }
    /**
     * Fetches search list and return it.
     */
    list(search, modelId, version, lang) {
        return __awaiter(this, void 0, void 0, function* () {
            const query = exports.SEARCH +
                `?s=${search}&model_id=${modelId}&version=${version}&lang=${lang}`;
            const headers = {};
            if (this.config.has('applicationId')) {
                headers['applicationId'] = this.config.get('applicationId');
            }
            if (this.config.has('identifier')) {
                headers['identifier'] = this.config.get('identifier');
            }
            try {
                const response = yield this.http.get({
                    path: query,
                    apiPrefix: http_1.APIPrefix.None,
                    backend: http_1.Backend.None,
                    header: headers,
                });
                if (!response.ok) {
                    console.error(yield response.json());
                    return [];
                }
                return (yield response.json());
            }
            catch (error) {
                console.error(error);
            }
            return [];
        });
    }
}
exports.SearchAPI = SearchAPI;
